import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import './EsqueciSenhaPage.css';
import Footer from './Footer';

const RedefinirSenhaPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(true);
  const [tokenValido, setTokenValido] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const validarToken = async () => {
      try {
        const response = await api.get(`/api/validar-token-reset/${token}`);
        if (response.data.success) {
          setTokenValido(true);
        }
      } catch (error) {
        setTokenValido(false);
        setMessage(error.response?.data?.message || 'Link inválido ou expirado.');
      } finally {
        setValidating(false);
      }
    };

    if (token) {
      validarToken();
    } else {
      setValidating(false);
      setMessage('Token não fornecido.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (novaSenha !== confirmarSenha) {
      setMessage('As senhas não coincidem.');
      return;
    }

    if (novaSenha.length < 8) {
      setMessage('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(novaSenha)) {
      setMessage('A senha deve conter pelo menos uma letra minúscula, uma maiúscula e um número.');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/api/redefinir-senha', {
        token,
        novaSenha
      });

      if (response.data.success) {
        setSuccess(true);
        setMessage(response.data.message);
      }
    } catch (error) {
      if (error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage('Erro ao redefinir senha. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (validating) {
    return (
      <div className="esqueci-senha-container">
        <div className="esqueci-senha-header">
          <Link to="/" className="logo-link">
            <div className="logo-wrapper-small">
              <div className="logo-circle-small">
                <img src="/logo.png" alt="IGL Coatings Logo" />
              </div>
            </div>
          </Link>
          <h1>Redefinir Senha</h1>
          <p>Verificando link...</p>
        </div>
        <div className="esqueci-senha-content">
          <div className="esqueci-senha-form" style={{ textAlign: 'center' }}>
            <p style={{ color: '#666' }}>Validando seu link de redefinição...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!tokenValido && !success) {
    return (
      <div className="esqueci-senha-container">
        <div className="esqueci-senha-header">
          <Link to="/" className="logo-link">
            <div className="logo-wrapper-small">
              <div className="logo-circle-small">
                <img src="/logo.png" alt="IGL Coatings Logo" />
              </div>
            </div>
          </Link>
          <h1>Link Inválido</h1>
          <p>Este link não é mais válido</p>
        </div>
        <div className="esqueci-senha-content">
          <div className="esqueci-senha-form">
            <div className="form-message form-message-error">
              {message}
            </div>
            <button
              type="button"
              className="submit-btn"
              onClick={() => navigate('/esqueci-senha')}
            >
              Solicitar Novo Link
            </button>
            <button
              type="button"
              className="go-login-btn"
              onClick={() => navigate('/login')}
            >
              Voltar ao Login
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="esqueci-senha-container">
      <div className="esqueci-senha-header">
        <div className="logo-wrapper-small">
          <div className="logo-circle-small">
            <img src="/logo.png" alt="IGL Coatings Logo" />
          </div>
        </div>
        <h1>Redefinir Senha</h1>
        <p>{success ? 'Senha redefinida com sucesso!' : 'Digite sua nova senha'}</p>
      </div>

      <div className="esqueci-senha-content">
        {!success ? (
          <form onSubmit={handleSubmit} className="esqueci-senha-form">
            <div className="form-group">
              <label>Nova Senha *</label>
              <input
                type={showPassword ? 'text' : 'password'}
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                placeholder="Digite sua nova senha"
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label>Confirmar Nova Senha *</label>
              <input
                type={showPassword ? 'text' : 'password'}
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                placeholder="Confirme sua nova senha"
                required
                minLength={8}
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', color: '#666' }}>
                <input
                  type="checkbox"
                  checked={showPassword}
                  onChange={(e) => setShowPassword(e.target.checked)}
                  style={{ width: 'auto', margin: 0 }}
                />
                Mostrar senhas
              </label>
            </div>

            {message && (
              <div className="form-message form-message-error">
                {message}
              </div>
            )}

            <div className="esqueci-senha-info" style={{ marginBottom: '16px' }}>
              <div className="info-card" style={{ background: 'rgba(0, 177, 64, 0.05)', border: '1px solid rgba(0, 177, 64, 0.15)', color: '#555' }}>
                <p style={{ margin: '0', fontSize: '13px', opacity: 1 }}>A senha deve conter:</p>
                <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 1, color: novaSenha.length >= 8 ? '#28a745' : '#999' }}>
                  {novaSenha.length >= 8 ? '✓' : '○'} No mínimo 8 caracteres
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 1, color: /[a-z]/.test(novaSenha) ? '#28a745' : '#999' }}>
                  {/[a-z]/.test(novaSenha) ? '✓' : '○'} Uma letra minúscula
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 1, color: /[A-Z]/.test(novaSenha) ? '#28a745' : '#999' }}>
                  {/[A-Z]/.test(novaSenha) ? '✓' : '○'} Uma letra maiúscula
                </p>
                <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 1, color: /\d/.test(novaSenha) ? '#28a745' : '#999' }}>
                  {/\d/.test(novaSenha) ? '✓' : '○'} Um número
                </p>
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Redefinindo...' : 'Redefinir Senha'}
            </button>
          </form>
        ) : (
          <div className="esqueci-senha-form">
            <div className="form-message form-message-success">
              {message}
            </div>
            <button
              type="button"
              className="submit-btn"
              onClick={() => navigate('/login')}
            >
              Ir para o Login
            </button>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default RedefinirSenhaPage;
